import * as Yup from 'yup';

export default Yup.object().shape({
    categoryId: Yup.number().required('Required'),
    message: Yup.string().required("Required"),
});